<template>
  <div class="tips-info">
    <div class="tips-img">
      <p><span class="tips-bg-1"></span></p>
      <p><span class="tips-bg-2"></span></p>
    </div>
    <div class="tips-content">
      <span class="quote quote-l"></span>
      <span class="quote quote-r"></span>
      <p class="tips-p">穿衣颜色属于行为风水，特殊日子</p>
      <p class="tips-p">特别场合，可不受此影响</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TipsInfo',
  props: {},
  data() {
    return {};
  }
}
</script>

<style scoped>
.tips-info {
  padding: 3rem 0 5rem 0;
  text-align: center;
}
.tips-bg-1 {
  display: inline-block;
  width: 2rem;
  height: 4rem;
  background: url('../../assets/images/dress/tips-arrow.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.tips-bg-2 {
  display: inline-block;
  width: 5rem;
  height: 2rem;
  background: url('../../assets/images/dress/tips.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.tips-content {
  position: relative;
  padding: 1rem 0;
}
.tips-content .quote {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.tips-content .quote.quote-l {
  left: 1.25rem;
  top: 1rem;
  background-image: url('../../assets/images/dress/tips-quote-l.png');
}
.tips-content .quote.quote-r {
  right: 1.25rem;
  top: 1.25rem;
  background-image: url('../../assets/images/dress/tips-quote-r.png');
}
.tips-p {
  font-size: 1rem;
  color: #999;
}
</style>
